export type Category = {
    id: number;
    title: string;
    description: string;
    iconame: string;
};

export function getCategoryById(id: number, list: Category[]): Category | undefined {
    return list.find(c => c.id === id);
}
